import { RouterProvider } from 'react-router-dom'
import { StagingIndicator } from 'src/components'
import { ToastContainer } from 'react-toastify'
import { createRouter } from './routes/routes'

import { useMemo } from 'react'
import { AppProvider } from './AppProvider'

const AppRouter = () => {
  const router = useMemo(() => createRouter(), [])

  return <RouterProvider router={router} />
}

const App = () => (
  <AppProvider>
    {process.env.REACT_APP_ENV === 'staging' && <StagingIndicator />}
    <AppRouter />
    <ToastContainer
      theme='colored'
      hideProgressBar
      autoClose={3000}
      closeButton={false}
      position='top-center'
      style={{ textAlign: 'center' }}
    />
  </AppProvider>
)

export default App
